// ════════════════════════════════════════════════════════════
// Mongol Refinery — API helper functions
//
// Backend нь зөвхөн нэг төрлийн token-той (admin AUTH_KEY).
// Frontend Authorization header: "Bearer <token>"
// ════════════════════════════════════════════════════════════

const authHeader = (isfile) => {
    let user;
    if (typeof window !== 'undefined') {
        try {
            user = JSON.parse(localStorage.getItem('user'));
        } catch (e) {
            user = null;
        }
    }

    const token = user ? user.token : null;

    const baseHeaders = isfile
        ? { Accept: 'application/json' }
        : { Accept: 'application/json', 'Content-Type': 'application/json' };

    if (token) {
        return { ...baseHeaders, Authorization: `Bearer ${token}` };
    }
    return baseHeaders;
};

const setHeader = (method = 'GET', isfile = false) => {
    return {
        method,
        headers: authHeader(isfile),
    };
};

const API_HOST = process.env.NEXT_PUBLIC_HOSTNAME;

export const get = async (target) => {
    const options = setHeader();
    const response = await fetch(API_HOST + target, options);
    const result = await response.json();
    return result;
};

export const put = async (target, data) => {
    const options = setHeader('PUT');
    options.body = JSON.stringify(data);
    const response = await fetch(API_HOST + target, options);
    return response.json();
};

export const post = async (target, data) => {
    const options = setHeader('POST');
    options.body = JSON.stringify(data);
    const response = await fetch(API_HOST + target, options);
    return response.json();
};

export const destroy = async (target, data) => {
    const options = setHeader('DELETE');
    if (data) options.body = JSON.stringify(data);
    const response = await fetch(API_HOST + target, options);
    return response.json();
};

// multipart/form-data upload — Content-Type-г bf-aa-аар нь үлдээнэ (browser-ээс)
export const upload = async (target, data) => {
    const options = setHeader('POST', true);
    options.body = data;
    const response = await fetch(API_HOST + target, options);
    return response.json();
};

export const uploadWithProgress = (target, data, onProgress) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const headers = setHeader('POST', true).headers || {};

        xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable && onProgress) {
                onProgress(Math.round((e.loaded / e.total) * 100));
            }
        });

        xhr.addEventListener('load', () => {
            try {
                resolve(JSON.parse(xhr.responseText));
            } catch {
                reject(new Error('JSON parse error'));
            }
        });

        xhr.addEventListener('error', () => reject(new Error('Upload failed')));
        xhr.addEventListener('abort', () => reject(new Error('Upload aborted')));

        xhr.open('POST', API_HOST + target);
        Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
        xhr.send(data);
    });
};

export const uploadPut = async (target, data) => {
    const options = setHeader('PUT', true);
    options.body = data;
    const response = await fetch(API_HOST + target, options);
    return response.json();
};

export const downloadFile = async (target, filename) => {
    const options = setHeader('GET', true);
    const response = await fetch(API_HOST + target, options);
    if (!response.ok) return { error: 'Татах боломжгүй' };
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    a.click();
    URL.revokeObjectURL(url);
    return { status: 'success' };
};

export const getBlob = async (target) => {
    const options = setHeader('GET', true);
    const response = await fetch(API_HOST + target, options);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
};
